export default {
  serverList: {
    common: ['CommonUI.Controls'],
    feature: 'Feature.ServerList'
  },
  privateServer: {
    common: [],
    feature: 'Feature.PrivateServers'
  },
  purchaseDialog: {
    common: [],
    feature: 'Purchasing.PurchaseDialog'
  },
  vipServersResources: {
    common: [],
    feature: 'Feature.VIPServer'
  }
};
